module.exports = __webpack_public_path__ + "static/img/PayID-22000.21c2f11f.svg";